import {createContext, useReducer} from "react";

const initData = {
    priceGross: 0,
    priceNett: 0,
    elements: [],
    allowAddToCart: false,
    isPriceLoading: false,
}
export const PriceContext = createContext(null);
export const PriceDispatch = createContext(null);
export const PriceProvider = ({children}) => {
    const [data, dispatch] = useReducer(
        PriceReducer,
        initData
    )
    return (
        <PriceContext.Provider value={data}>
            <PriceDispatch.Provider value={dispatch}>
                {children}
            </PriceDispatch.Provider>
        </PriceContext.Provider>
    )
}

function PriceReducer(data, action) {
    switch (action.type) {
        case "updatePrice":
            const newElements = [...data.elements];
            if (!newElements[action.payload.index]) {
                newElements[action.payload.index] = {
                    priceNett: action.payload.priceNett,
                    priceGross: action.payload.priceGross,
                }
            } else {
                newElements[action.payload.index] = {
                    ...newElements[action.payload.index],
                    priceNett: action.payload.priceNett,
                    priceGross: action.payload.priceGross,
                };
            }
            let priceGross = 0;
            let priceNett = 0;
            newElements.forEach((element) => {
                if (element.priceGross) {
                    priceGross += parseFloat(element.priceGross);
                }
                if (element.priceNett) {
                    priceNett += parseFloat(element.priceNett);
                }
            });
            return {
                ...data,
                elements: newElements,
                priceGross: priceGross,
                priceNett: priceNett,
            };
        case "resetPrice":
            return {
                ...data,
                priceGross: 0,
                priceNett: 0,
                elements: [],
            }
        case "setAllowAddToCart":
            return {
                ...data,
                allowAddToCart: action.payload
            }
        case "setPriceLoading":
            return {
                ...data,
                isPriceLoading: action.payload
            }
        default:
            throw Error('Unknown action: ' + action.type);
    }
}